import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  FiFileText,
  FiSettings,
  FiBriefcase,
  FiAward,
  FiUsers,
  FiHeart,
  FiUserCheck,
  FiTrendingUp,
  FiGithub,
  FiCode
} from "react-icons/fi";
import { FaChartBar, FaTrophy } from "react-icons/fa";

const HRPolicies = () => {
  const dispatch = useDispatch();
  const [openAccordion, setOpenAccordion] = useState(null);

  dispatch(updateNavbarHeading("Policies"));

  const toggleAccordion = (accordionId) => {
    setOpenAccordion(openAccordion === accordionId ? null : accordionId);
  };

  const policies = [
    {
      id: "leave",
      title: "Leave Policy",
      icon: <FiFileText />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Leave%20Policy.pdf",
      className: "icon-leave"
    },
    {
      id: "travel",
      title: "Travel Expense Policy",
      icon: <FiFileText />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Travel%20&%20Expense%20Policy.pdf",
      className: "icon-travel"
    },
    {
      id: "it",
      title: "Information Technology (IT) Policy",
      icon: <FiSettings />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Information Technology (IT) Policy 3.2_2026.pdf",
      className: "icon-it"
    },
    {
      id: "incentives",
      title: "Incentives Policy",
      icon: <FiAward />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Incentives%20&%20Bonus%20Policy.pdf",
      className: "icon-incentives"
    },
    {
      id: "dei",
      title: "Diversity, Equity & Inclusion Policy",
      icon: <FiUsers />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Diversity,%20Equity%20&%20Inclusion%20Policy.pdf",
      className: "icon-dei"
    },
    {
      id: "mediclaim",
      title: "Mediclaim Insurance Guide",
      icon: <FiHeart />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/MEDICLAIM%20INSURANCE%20GUIDE.pdf",
      className: "icon-mediclaim"
    },
    // {
    //   id: "roles",
    //   title: "Roles and Responsibilities",
    //   icon: <FiUserCheck />,
    //   url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Roles_and_Responsilbilities.pdf",
    //   className: "icon-roles"
    // },
    {
      id: "social-media",
      title: "Social Media Policy",
      icon: <FiGithub />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Social%20Media%20Policy.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "fraternization",
      title: "Workplace Fraternization Policy",
      icon: <FiBriefcase />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Workplace%20Fraternization%20Policy.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "conduct",
      title: "Code Of Conduct",
      icon: <FiCode />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Code%20of%20Conduct.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "certification",
      title: "Training & Certification Policy",
      icon: <FiFileText />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Training%20&%20Certification%20Policy.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "kpis",
      title: "KPI/KRAs - Roles &Responsibilities",
      icon: <FaChartBar />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/KPI-KRA_ Roles & Responsibilities.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "cp-kras-kpis",
      title: "Client Partner KRAs and KPIs",
      icon: <FaChartBar />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/NICE_CP KRAs and KPIs 2026.pdf",
      className: "icon-mediclaim"
    },
    {
      id: "reward-recog-policy",
      title: "Rewards & Recognition Policy",
      icon: <FaTrophy />,
      url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Rewards & Recognition Policy.pdf",
      className: "icon-mediclaim"
    },
  ];

  const nestedPolicies = [
    {
      id: "performance",
      title: "Performance Improvement Plan",
      icon: <FiTrendingUp />,
      className: "icon-performance",
      items: [
        {
          title: "Guidelines",
          icon: <FiHeart />,
          url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Performance_Improvement_Plan.pdf",
          className: "icon-mediclaim"
        },
        {
          title: "Evaluation Sheet",
          icon: <FiUserCheck />,
          url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Performance_Improvement_Plan_Evaluation_Sheet.pdf",
          className: "icon-roles"
        }
      ]
    },
    {
      id: "dubai",
      title: "Dubai Policies",
      icon: <FiFileText />,
      className: "icon-performance",
      items: [
        {
          title: "Dubai Leave Policy",
          icon: <FiUserCheck />,
          url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Dubai_Leave_Policy.pdf",
          className: "icon-mediclaim"
        },
        {
          title: "Dubai Onboarding Guidelines",
          icon: <FiUserCheck />,
          url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Dubai_Onboarding_Guidelines.pdf",
          className: "icon-roles"
        },
        {
          title: "Dubai Visa Process",
          icon: <FiUserCheck />,
          url: "https://api.nicesoftwaresolutions.com/storage/uploads/knowledge_base/Dubai_Visa_Process.pdf",
          className: "icon-roles"
        }
      ]
    }
  ];

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="policies-accordion">
          {/* Simple Policies */}
          {policies.map((policy) => (
            <div className="policies-accordion-item" key={policy.id}>
              <button className="policies-accordion-header">
                <div className="header-left">
                  <div className={`policies-icon-container ${policy.className}`}>
                    {policy.icon}
                  </div>
                  <span className="policies-accordion-title">
                    <a
                      href={policy.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <strong>{policy.title}</strong>
                    </a>
                  </span>
                </div>
              </button>
            </div>
          ))}

          {/* Nested Policies */}
          {nestedPolicies.map((policy) => (
            <div className="policies-accordion-item" key={policy.id}>
 <button
  className={`policies-accordion-header ${
    openAccordion === policy.id ? "active" : ""
  }`}
  onClick={() => toggleAccordion(policy.id)}
>
  <div className="d-flex justify-content-between align-items-center w-100">
    <div className="d-flex align-items-center">
      <div className={`policies-icon-container ${policy.className}`}>
        {policy.icon}
      </div>
      <span className="policies-accordion-title ms-2">
        <strong>{policy.title}</strong>
      </span>
    </div>

    <span className="policies-accordion-title">
      <strong>
        <i className="bi bi-chevron-down"></i>
      </strong>
    </span>
  </div>
</button>

              <div
                className={`policies-accordion-content ${
                  openAccordion === policy.id ? "active" : ""
                }`}
              >
                {policy.items.map((item, index) => (
                  <div className="policies-accordion-item" key={index}>
                    <button className="policies-accordion-header">
                      <div className="header-left" style={{ marginLeft:"10px"}}>
                        <div className={`policies-icon-container ${item.className}`}>
                          {item.icon}
                        </div>
                        <span className="policies-accordion-title">
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <strong>{item.title}</strong>
                          </a>
                        </span>
                      </div>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HRPolicies;